/**
* @author Andrés Camilo Ferreira Rodríguez
* @Copyright (c) Infotrack. All rights reserved.
*/
export default {
'sidebar.smartstock': 'Smart  Stock',
'sidebar.etapas': 'Etapas',
'etapas.agregarEtapas': 'Create Etapas',
'etapas.modificarEtapas': 'Edit Etapas',
'etapas.eliminarEtapas': 'Delete Etapas',
'etapas.etapaId': 'Etapa   Id ',
'etapas.empresaId': ' Empresa   Id ',
'etapas.etapaDescripcion': ' Etapa   Descripcion',
'etapas.etapas': 'Etapas',
'etapas.verEtapas': 'View Etapas',
'etapas.EtapaInactivo': 'Inactive record stage, select a new one' 

};

